/* MYNTELO v7 A.4 product page (2026-11-02). Loaded (defer) by sections/main-product.liquid.
   1. Searchable Model picker: a combobox over the native Model <select>, which stays the source of truth (Dawn variant-selects,
      the v5.9 "Choose your model" gate, assets/myntelo-device.js guesses/chips, assets/myntelo-flow.js phone sheet and the 3D stage
      all keep working through it). Typing "17 pro m" shows iPhone 17 Pro Max. Keyboard: arrows, Enter, Escape. The pick is shown as a chip.
   2. The one sticky bar (Features, FAQs, Reviews + thumb, name, price, Add to bag): on once the buy box's Add to bag scrolls out.
   3. Phone-colour list on the left edge of the hero frame (desktop): mirrors the 3D viewer's own swatches and clicks them,
      so the viewer's colour logic (setColor, the "Phone color" line property, localStorage) is unchanged.
   v7 C (2026-11-03): a user's Model pick (searchable picker, or a real change of the plain Model dropdown) fires the theme's Clarity
   tag model_chosen (set + event, as assets/myntelo-flow.js does) and the dataLayer push myntelo_device_pick (how 'pdp-picker' /
   'pdp-dropdown'). Programmatic changes (the v5.5 preselect, assets/myntelo-device.js; the phone sheet, which tags itself) never do.
   v7 B (2026-11-03): on desktop the sticky bar stays off while the real Add to bag is in view (the buy box column is sticky beside
   the photo stack, snippets/myntelo-v7-photos.liquid), so there is only ever one sticky Add to bag. */
(function () {
  'use strict';
  var D = document, W = window;
  var root = D.querySelector('[data-v7-pdp]');
  if (!root) return;
  var sid = root.getAttribute('data-section');
  var form = D.getElementById('product-form-' + sid);
  var reduce = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var phone = W.matchMedia ? W.matchMedia('(max-width: 749px)') : { matches: false };
  var wide = W.matchMedia ? W.matchMedia('(min-width: 990px)') : { matches: false };
  var KEY = 'myntelo:device';

  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || D).querySelectorAll(s)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function kindOf(m) { return /^iPhone/i.test(m || '') ? 'iphone' : /^Samsung Galaxy/i.test(m || '') ? 'galaxy' : null; }
  function emit(name, d) {
    try { var o = { event: name }; for (var k in d) o[k] = d[k]; (W.dataLayer = W.dataLayer || []).push(o); } catch (e) {}
    try { if (W.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, d); } catch (e) {}
  }
  /* v7 C: one user pick = one Clarity model_chosen tag + one dataLayer push */
  function picked(model, how) {
    var kind = kindOf(model);
    if (!model || !kind) return;
    emit('myntelo_device_pick', { brand: kind, model: model, how: how });
    try { if (typeof W.clarity === 'function') { W.clarity('set', 'model_chosen', String(model)); W.clarity('event', 'model_chosen'); } } catch (e) {}
  }
  function atc() { return form ? form.querySelector('[type="submit"][name="add"]') : null; }
  function gated() { var b = atc(); return !!(b && (b.hasAttribute('data-mx-choose') || b.getAttribute('aria-disabled') === 'true')); }

  /* ---------------- 1. searchable Model picker ---------------- */
  function modelSelect() {
    var list = $$('variant-selects select, variant-radios select', root);
    for (var i = 0; i < list.length; i++) {
      var s = list[i], lab = D.querySelector('label[for="' + s.id + '"]');
      var name = ((lab && lab.textContent) || s.name || '').toLowerCase();
      if (name.indexOf('model') >= 0 && realOpts(s).length > 1) return s;
    }
    return null;
  }
  function realOpts(s) { return [].filter.call(s.options, function (o) { return o.value !== ''; }); }
  function words(t) { return String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(' ').filter(Boolean); }
  function compact(t) { return String(t || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
  function matches(label, q) {
    var toks = words(q);
    if (!toks.length) return true;
    var w = words(label);
    var byWord = toks.every(function (k) { return w.some(function (x) { return x.indexOf(k) === 0; }); });
    return byWord || compact(label).indexOf(compact(q)) >= 0;
  }

  function combo(sel) {
    var wrap = sel.closest('.product-form__input');
    var vs = sel.closest('variant-selects, variant-radios');
    if (!wrap || !vs || vs._v7) return;
    vs._v7 = 1;
    wrap.classList.add('v7-native');
    sel.setAttribute('tabindex', '-1');
    var id = 'v7m-' + sid;
    var box = D.createElement('div');
    box.className = 'v7-model';
    box.innerHTML =
      '<label class="v7-model__label" for="' + id + '-q">Model</label>' +
      '<div class="v7-model__chip" data-v7-chip hidden><span>Fits <b data-v7-chip-name></b></span><button type="button" class="v7-model__change" data-v7-change>Change</button></div>' +
      '<div class="v7-model__field" data-v7-field>' +
        '<input id="' + id + '-q" class="v7-model__input" type="text" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="' + id + '-list" autocomplete="off" autocapitalize="off" spellcheck="false" enterkeyhint="done" placeholder="Search your model, e.g. 17 Pro Max">' +
        '<ul id="' + id + '-list" class="v7-model__list" role="listbox" aria-label="Phone models" hidden></ul>' +
      '</div>';
    vs.parentNode.insertBefore(box, vs);
    /* our own events stay ours: Dawn, the 3D stage and the device script all listen for change on the document */
    ['change', 'input'].forEach(function (t) { box.addEventListener(t, function (e) { e.stopPropagation(); }); });

    var input = $('input', box), list = $('ul', box), chip = $('[data-v7-chip]', box), field = $('[data-v7-field]', box), chipName = $('[data-v7-chip-name]', box);
    var shown = [], active = -1;

    function opts() { return realOpts(sel).map(function (o) { return { v: o.value, t: o.textContent.trim(), off: o.disabled }; }); }
    function paint() {
      var q = input.value, all = opts(), cur = sel.value;
      shown = all.filter(function (o) { return matches(o.t, q); });
      if (active >= shown.length) active = shown.length - 1;
      if (!shown.length) { list.innerHTML = '<li class="v7-model__empty" role="presentation">No model matches “' + esc(q) + '”. Try “17 Pro” or “S25”.</li>'; input.removeAttribute('aria-activedescendant'); return; }
      list.innerHTML = shown.map(function (o, i) {
        return '<li id="' + id + '-o' + i + '" class="v7-model__opt' + (i === active ? ' is-active' : '') + '" role="option" aria-selected="' + (o.v === cur) + '"' + (o.off ? ' aria-disabled="true"' : '') + ' data-v="' + esc(o.v) + '">' + esc(o.t) + '</li>';
      }).join('');
      if (active >= 0) { input.setAttribute('aria-activedescendant', id + '-o' + active); var a = list.children[active]; if (a && a.scrollIntoView) a.scrollIntoView({ block: 'nearest' }); }
      else input.removeAttribute('aria-activedescendant');
    }
    function open() { if (!list.hidden) return; list.hidden = false; input.setAttribute('aria-expanded', 'true'); active = -1; paint(); }
    function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; }
    function syncChip() {
      var cur = sel.value, picked = !!cur && opts().some(function (o) { return o.v === cur; });
      chip.hidden = !picked;
      field.hidden = picked;
      if (picked) chipName.textContent = cur;
    }
    function choose(v, how, user) {
      if (!v) return;
      close();
      input.value = '';
      if (sel.value !== v) {
        sel.value = v;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        /* before the 3D stage is live it boots from data-model (same hand-off as assets/myntelo-device.js) */
        $$('[data-m3d]', root).forEach(function (r) {
          if (r._m3dSetModel) r._m3dSetModel(v);
          else if (!r.dataset.m3dReady && !r.dataset.glb) r.dataset.model = v;
        });
        var kind = kindOf(v);
        if (kind) {
          try { localStorage.setItem(KEY, JSON.stringify({ brand: kind, model: v, t: Date.now() })); } catch (e) {}
          if (user) picked(v, how || 'pdp-picker');
        }
      }
      syncChip();
      var c = $('[data-v7-change]', box);
      if (c) try { c.focus({ preventScroll: true }); } catch (e) {}
    }

    input.addEventListener('focus', open);
    input.addEventListener('click', open);
    input.addEventListener('input', function () { if (list.hidden) open(); active = input.value ? 0 : -1; paint(); });
    input.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowDown' || k === 'ArrowUp') {
        e.preventDefault();
        if (list.hidden) open();
        if (!shown.length) return;
        active = k === 'ArrowDown' ? Math.min(shown.length - 1, active + 1) : Math.max(0, active - 1);
        paint();
      } else if (k === 'Enter') {
        if (list.hidden) return;
        e.preventDefault();
        var pick = shown[active >= 0 ? active : (shown.length === 1 ? 0 : -1)];
        if (pick && !pick.off) choose(pick.v, 'pdp-picker', true);
      } else if (k === 'Escape') {
        if (!list.hidden) { e.preventDefault(); close(); }
      } else if (k === 'Tab') close();
    });
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('[role="option"]');
      if (li && li.getAttribute('aria-disabled') !== 'true') choose(li.getAttribute('data-v'), 'pdp-picker', true);
    });
    D.addEventListener('pointerdown', function (e) { if (!box.contains(e.target)) close(); });
    $('[data-v7-change]', box).addEventListener('click', function () {
      chip.hidden = true; field.hidden = false; input.focus();
    });
    /* the theme brings the hidden select into view and focuses it (desktop "Choose your model" tap): hand that to the search field */
    sel.addEventListener('focus', function () { chip.hidden = true; field.hidden = false; setTimeout(function () { input.focus(); }, 0); });
    sel.addEventListener('change', function (e) { syncChip(); if (e.isTrusted && sel.value) picked(sel.value, 'pdp-dropdown'); });
    D.addEventListener('change', function (e) { if (e.target === sel) syncChip(); });
    syncChip();
    W.MynteloV7Model = { open: function () { chip.hidden = true; field.hidden = false; input.focus(); open(); }, choose: function (v, how) { choose(v, how, false); } };
  }
  /* v7 C: the plain Model dropdown (no combobox yet, or the combobox did not attach): a real user change tags the pick */
  function nativeTag(s) {
    if (!s || s._v7Tag) return;
    s._v7Tag = 1;
    if (s.closest('variant-selects, variant-radios') && s.closest('variant-selects, variant-radios')._v7) return;
    s.addEventListener('change', function (e) { if (e.isTrusted && s.value) picked(s.value, 'pdp-dropdown'); });
  }
  function initCombo() { var s = modelSelect(); if (s) { combo(s); nativeTag(s); } }

  /* ---------------- 2. the one sticky bar ---------------- */
  function sticky() {
    var bar = $('[data-v7-sticky]');
    if (!bar || !form) return;
    var btn = $('[data-v7-sticky-btn]', bar), priceEl = $('[data-v7-sticky-price]', bar);
    var main = atc();
    var on = false, ticking = false;
    function hh() { var v = parseFloat(getComputedStyle(D.documentElement).getPropertyValue('--m-hh')); return isNaN(v) ? 88 : v; }
    function set(v) {
      if (v === on) return;
      on = v;
      bar.classList.toggle('is-on', v);
      bar.setAttribute('aria-hidden', String(!v));
      $$('a, button', bar).forEach(function (el) { if (v) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1'); });
      if (v) links();
    }
    /* On once the buy box's Add to bag has scrolled up behind the header, or the hero frame (the 3D stage) has scrolled out.
       Never while the real Add to bag sits in the bar's band (so it is never covered), never over the footer. */
    var stage = $('.m3d__stage', root) || $('.product__media-wrapper', root);
    function check() {
      ticking = false;
      if (!main) return;
      var top = hh(), r = main.getBoundingClientRect();
      var foot = $('.m-footer');
      var footIn = foot && foot.getBoundingClientRect().top < W.innerHeight * 0.6;
      var atcAbove = r.bottom < top;
      var s = stage && stage.getBoundingClientRect();
      var frameOut = !!(s && s.height && s.bottom < top);
      var inBand = r.bottom > top && r.top < top + 58;
      var atcSeen = wide.matches && r.top >= top + 58 && r.bottom <= W.innerHeight;
      set((atcAbove || frameOut) && !inBand && !footIn && !atcSeen);
      if (on) links();
    }
    W.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    W.addEventListener('resize', check);
    check();
    /* links to sections that are not on the page (e.g. no reviews yet) are hidden */
    function links() {
      $$('[data-v7-anchor]', bar).forEach(function (a) {
        var t = D.getElementById(a.getAttribute('href').slice(1));
        a.hidden = !(t && t.offsetParent !== null && t.getClientRects().length);
      });
    }
    links();
    bar.addEventListener('click', function (e) {
      var a = e.target.closest('[data-v7-anchor]');
      if (!a) return;
      var t = D.getElementById(a.getAttribute('href').slice(1));
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      try { history.replaceState(null, '', a.getAttribute('href')); } catch (x) {}
    });
    btn.addEventListener('click', function () {
      main = atc();
      if (!main) return;
      if (gated()) {
        if (phone.matches && W.MynteloPicker && W.MynteloPicker.open && W.MynteloPicker.open()) return;
        var m = $('.v7-model', root) || $('variant-selects', root);
        if (m) m.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        setTimeout(function () { if (W.MynteloV7Model) W.MynteloV7Model.open(); }, reduce ? 0 : 450);
        return;
      }
      if (main.disabled) return;
      main.click();
    });
    /* price follows the variant (Dawn re-renders #price-<section>) */
    var pr = D.getElementById('price-' + sid);
    function syncPrice() {
      if (!pr || !priceEl) return;
      var p = $('.price', pr);
      var el = p && p.classList.contains('price--on-sale') ? $('.price__sale .price-item--sale', pr) : $('.price__regular .price-item--regular', pr);
      var t = el && el.textContent.trim();
      if (t && priceEl.textContent !== t) priceEl.textContent = t;
    }
    if (pr && W.MutationObserver) new MutationObserver(syncPrice).observe(pr, { childList: true, subtree: true, characterData: true });
    syncPrice();
  }

  /* ---------------- 3. phone-colour list (desktop) ---------------- */
  function colors() {
    var m3d = $('.m3d[data-m3d]', root);
    if (!m3d || m3d.dataset.acc) return;
    var stage = $('.m3d__stage', m3d), sw = $('[data-m3d-swatches]', m3d);
    if (!stage || !sw) return;
    var box = D.createElement('div');
    box.className = 'v7-colors';
    box.setAttribute('role', 'group');
    box.setAttribute('aria-label', 'Phone color');
    box.hidden = true;
    stage.appendChild(box);
    function render() {
      var src = $$('.m3d__sw', sw);
      if (!src.length) { box.hidden = true; m3d.classList.remove('v7-has-colors'); return; }
      box.innerHTML = '<p class="v7-colors__head">Phone color</p>' + src.map(function (b, i) {
        var name = b.getAttribute('aria-label') || b.title || '';
        return '<button type="button" class="v7-colors__btn" data-i="' + i + '" aria-pressed="' + (b.getAttribute('aria-pressed') === 'true') + '"><span class="v7-colors__dot" style="background-color:' + esc(b.style.backgroundColor || '') + '"></span>' + esc(name) + '</button>';
      }).join('');
      box.hidden = false;
      m3d.classList.add('v7-has-colors');
    }
    box.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
    box.addEventListener('click', function (e) {
      var b = e.target.closest('.v7-colors__btn');
      if (!b) return;
      var src = $$('.m3d__sw', sw)[+b.getAttribute('data-i')];
      if (src) src.click();
    });
    if (W.MutationObserver) new MutationObserver(render).observe(sw, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-pressed', 'style'] });
    render();
  }

  function init() { initCombo(); sticky(); colors(); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
  D.addEventListener('shopify:section:load', function () { initCombo(); });
})();
